export default __webpack_public_path__ + "static/media/man_mittel_front.027817e2.jpg";